exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".el-row{margin-bottom:20px}.el-row:last-child{margin-bottom:0}@media (max-width:990px){.el-col{margin-bottom:20px}.el-col:last-child{margin-bottom:0}}", ""]);

// exports
